import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { BM_MODULE_NAMESPACE, BM_GET_BMS, BM_SET_VALUE_BY_FIELD, BM_RESET_BMS, BM_SET_LOADER_STATE, BM_LOADERS } from '../../../store/building-monitor/bm-types.store'
import { IPagination } from '../../../models/generic'
import { IBMParameter, IBMListingViewModel } from '../../../models/bm'
import { ActivityStatus } from '../../../common/enums'
import {AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE} from "../../../store/authorization";
const BMStore = namespace(BM_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'list-condition': async () => import('../components/bm-conditions/BMConditions.vue'),
    'list-item': async () => import('../components/building-monitor-list-item/BuildingMonitorListItem.vue'),
    'bm-list-loader': async () => import('../loaders/bm-list-loader/BMListLoader.vue')
  }
})
class BMChildListContainer extends Vue {

  constructor () {
    super()
  }

  mounted () {
    this.loadFunctionality()
  }

  @BMStore.Getter activityStatus: ActivityStatus;
  @BMStore.Getter pagination: IPagination;
  @BMStore.Getter bmParameter: IBMParameter;
  @BMStore.Getter bmsSource: { activityStatus: ActivityStatus, data: IBMListingViewModel[] };

  @BMStore.Mutation(BM_SET_VALUE_BY_FIELD)
  storeAssignValueForBMParameter: (value: { [x: string]: any }) => void;
  @BMStore.Mutation(BM_RESET_BMS)
  storeResetBMs: () => void;
  @BMStore.Mutation(BM_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @BMStore.Action(BM_GET_BMS)
  storeGetBMs: (payload: { param: IBMParameter, merge: boolean }) => Promise<any>;

  get lblSetting () {
    return {
      ...require('@/locales/building-monitor').default
    }
  }
  get bmsViewModel (): IBMListingViewModel[] {
    return this.bmsSource.data
  }
  get coSearchParameter (): IBMParameter {
    return this.bmParameter
  }
  set coSearchParameter (value: IBMParameter) {
    this.storeAssignValueForBMParameter(value)
  }

  get searchParam () {
    return { param: this.coSearchParameter, merge: true }
  }

  setListLoaderState (value: boolean) {
    this.storeSetLoaderState({ key: BM_LOADERS.LIST, value })
  }

  loadFunctionality () {
    this.storeGetFunctionalities(BM_MODULE_NAMESPACE)
      .then(response => {
        if (this.$route.meta) {
          Object.keys(response).forEach(key => { this.$route.meta[key] = true })
        }
      })
      .catch(error => console.log(error))
  }
}

export default BMChildListContainer



// WEBPACK FOOTER //
// ./src/containers/building-monitor/building-monitor-child-list/index.ts